import { useAppConfig } from '@jwp/ott-hooks-react/src/useAppConfig';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MarkdownComponent from '../../components/MarkdownComponent/MarkdownComponent';
import HTMLRenderer from '../HTMLRender/HTMLRender';
import styles from './TermsOfUse.module.scss';
import { markdownPageEnglish, markdownPageSpanish } from './TermsOfUseContent';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import BackArrowIcon from '@jwp/ott-theme/assets/icons/back_arrow.svg?react';
import IconButton from '../IconButton/IconButton';
import Icon from '../Icon/Icon';
import { useNavigate, useLocation } from 'react-router';

type Props = {
  panelClassName?: string;
  panelHeaderClassName?: string;
};

const TermsOfUse = ({ panelClassName }: Props): JSX.Element => {
  const { canShowTermsOfUse } = useAppConfig();
  const termsOfUse = useConfigStore((state) => state.termsOfUse);
  const { i18n, t } = useTranslation('common');
  const location = useLocation();

  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const showBack = location.pathname.startsWith('/terms-of-use');

  const markdownContent = () => {
    if (i18n.language === 'en') return markdownPageEnglish;
    if (i18n.language === 'es') return markdownPageSpanish;
    return 'Language not supported';
  };

  if (!termsOfUse?.en && !termsOfUse?.es && canShowTermsOfUse) {
    return (
      <>
        {showBack && (
          <div className={styles.headerTitlePart}>
            <IconButton className={styles.iconButton} aria-controls="sidebar" aria-haspopup="true" onClick={handleBackClick}>
              <Icon icon={BackArrowIcon} />
            </IconButton>
          </div>
        )}
        <section className={panelClassName}>
          <MarkdownComponent className={styles.about} markdownStyle={styles.markdown} markdownString={markdownContent()} />
        </section>
      </>
    );
  }

  return (
    <>
      {showBack && (
        <div className={styles.headerTitlePart}>
          <IconButton className={styles.iconButton} aria-controls="sidebar" aria-haspopup="true" onClick={handleBackClick}>
            <Icon icon={BackArrowIcon} />
          </IconButton>
        </div>
      )}
      <section className={panelClassName}>
        <HTMLRenderer
          className={styles.legalDocsContainer}
          html={i18n.language === 'es' ? (termsOfUse?.es ? termsOfUse?.es : termsOfUse?.en) : termsOfUse?.en}
        />
      </section>
    </>
  );
};

export default TermsOfUse;
